export const TOOLTIP = {
    TOP: 'tooltip-top',
    RIGHT: 'tooltip-right',
    BOTTOM: 'tooltip-bottom',
    BOTTOM_OFFSET_RIGHT: 'tooltip-bottom-offset-right',
    LEFT: 'tooltip-left',
    MODAL: 'tooltip-modal',
};
